import { ISSUE_EVENTS } from './constants';
import type { GqlsRealtimeEvent, IssueEvent, RealtimeResponse } from './types';

export const isIssueEvent = (event: GqlsRealtimeEvent): event is IssueEvent =>
	ISSUE_EVENTS.includes(event.type);

export const getResponseError = (response: RealtimeResponse) =>
	Array.isArray(response.errors) && response.errors.length && response.errors[0].message;
